import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const SubmittedPayrolls = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div class="row mx-0 payroll-page">
              <div class="shadowclass mt-4">
                <h4 class="event-alert">Submitted Payrolls </h4>
                <div class="col-md-4">
                  <div class="search-box mt-0">
                    <form type="GET">
                      <input type="text" placeholder="Search" name="keyword1" />
                      <input type="submit" />
                    </form>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="checklist-table remove-space ingredTable">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Payroll Period</th>
                        <th># of Employees</th>
                        <th>Total Cost</th>
                        <th>Submitted By</th>
                        <th>Submission Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span class="">Complete Submission</span>
                        </td>
                        <td>2022-07-01 - 2022-07-31</td>
                        <td>13</td>
                        <td>$55,472.72</td>
                        <td>Daniel Ballis</td>
                        <td>2022-07-21</td>
                        <td>
                          <div className="d-flex">
                            <a
                              class="circle_icon"
                              href="/payrolls/view_payroll?payrollPeriodId=1238"
                            >
                              <i class="eye-icon iconSprites"></i>
                            </a>
                            <a
                              class="circle_icon"
                              target="_blank"
                              href="/payrolls/generate_e_submission_file/1238"
                            >
                              <i class="iconSprites download-sm-icon">
                                <div class="tooltip-sm">
                                  {" "}
                                  Download E-Submission File{" "}
                                </div>
                              </i>
                            </a>

                            <a class="circle_icon" target="_blank" href="#_">
                              <i class="iconSprites download-sm-icon">
                                <div class="tooltip-sm">
                                  {" "}
                                  Download Bank File{" "}
                                </div>
                              </i>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span class="">Complete Submission</span>
                        </td>
                        <td>2022-07-01 - 2022-07-31</td>
                        <td>13</td>
                        <td>$55,472.72</td>
                        <td>Daniel Ballis</td>
                        <td>2022-07-21</td>
                        <td>
                          <a
                            class="circle_icon"
                            href="/payrolls/view_payroll?payrollPeriodId=1238"
                          >
                            <i class="eye-icon iconSprites"></i>
                          </a>
                          <a
                            class="circle_icon"
                            target="_blank"
                            href="/payrolls/generate_e_submission_file/1238"
                          >
                            <i class="iconSprites download-sm-icon">
                              <div class="tooltip-sm">
                                {" "}
                                Download E-Submission File{" "}
                              </div>
                            </i>
                          </a>

                          <a class="circle_icon" target="_blank" href="#_">
                            <i class="iconSprites download-sm-icon">
                              <div class="tooltip-sm"> Download Bank File </div>
                            </i>
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span class="">Complete Submission</span>
                        </td>
                        <td>2022-07-01 - 2022-07-31</td>
                        <td>13</td>
                        <td>$55,472.72</td>
                        <td>Daniel Ballis</td>
                        <td>2022-07-21</td>
                        <td>
                          <a
                            class="circle_icon"
                            href="/payrolls/view_payroll?payrollPeriodId=1238"
                          >
                            <i class="eye-icon iconSprites"></i>
                          </a>
                          <a
                            class="circle_icon"
                            target="_blank"
                            href="/payrolls/generate_e_submission_file/1238"
                          >
                            <i class="iconSprites download-sm-icon">
                              <div class="tooltip-sm">
                                {" "}
                                Download E-Submission File{" "}
                              </div>
                            </i>
                          </a>

                          <a class="circle_icon" target="_blank" href="#_">
                            <i class="iconSprites download-sm-icon">
                              <div class="tooltip-sm"> Download Bank File </div>
                            </i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default SubmittedPayrolls;
